import { render } from "./InputEducation.vue?vue&type=template&id=6f280366"
import script from "./InputEducation.vue?vue&type=script&lang=js"
export * from "./InputEducation.vue?vue&type=script&lang=js"
script.render = render

export default script